import { uiCoreI18nSource } from '@tencent/ui-core';
import { enMerged } from './en';
import { zh } from './zh';
import VueI18n from 'vue-i18n';
import Vue from 'vue';
import { Lang } from './lang';
import { CustomFormatter } from './formatter';
const zhWithDefault = Object.keys(zh).length
    ? zh
    : Object.assign({}, Object.keys(enMerged).reduce((obj, key) => {
        Object.assign(obj, { [key]: key });
        return obj;
    }, {}), zh);
const messages = {
    [Lang.English]: { ...enMerged, ...uiCoreI18nSource?.[Lang.English] },
    [Lang.Chinese]: { ...zhWithDefault, ...uiCoreI18nSource?.[Lang.Chinese] },
};
export const i18nOptions = {
    locale: window.langController.getLang(),
    fallbackLocale: Lang.Chinese,
    messages,
    silentTranslationWarn: true,
    formatter: new CustomFormatter(),
};
Vue.use(VueI18n);
export const i18n = new VueI18n(i18nOptions);
export const $t = (...args) => i18n.t(...args);
// ui-core 使用
window.xy_$t = $t;
Vue.prototype.$t = $t;
